import { HttpClient } from "../api/httpclient.service";
import { useUserStore } from "../../utils/userStore";

type TrackType = "pageview" | "customevent";

interface TrackingPayload {
  track_type: TrackType;
  page_name?: string;
  event_name?: string;
  url?: string;
  properties: Record<string, string | null>;
}

export class TrackingService extends HttpClient {
  constructor() {
    super();
  }

  private getUserTrackingProperties(): Record<string, string> {
    const userAttributes = useUserStore.getState().user_attributes || {};
    const userInfo = useUserStore.getState().userInfo || {};
    return {
      "email": userInfo.email ?? "unknown",
      "role": `${userAttributes.user_type}`,
    };
  }

  private async _sendTracking(data: TrackingPayload): Promise<any> {
    try {
      const fullPayload: TrackingPayload = {
        ...data,
        properties: {
          ...this.getUserTrackingProperties(),
          ...(data.properties || {}),
        },
      };

      const response = await this.post("/data_collector/tracking", fullPayload);
      return response;
    } catch (error) {
      console.error("Error sending tracking data:", error);
      return null;
    }
  }

  public async trackEvent(eventName: string, properties: Record<string, string | null> = {}): Promise<any> {
    return this._sendTracking({
      track_type: "customevent",
      event_name: eventName,
      properties,
    });
  }

  public async trackPageView(
    pageName: string,
    url: string = window.location.href,
    duration: number | null = null,
    properties: Record<string, string> = {}
  ): Promise<any> {
    return this._sendTracking({
      track_type: "pageview",
      page_name: pageName,
      url,
      properties,
    });
  }
}
